// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"cd7363ed","98":"0ad68dc0","215":"6117d6d9","294":"ddfdb084","338":"e430e479","341":"f41bfe3d","437":"11a3e5de","453":"33c8c630","566":"ac0d8b32","630":"5a0f1acc","635":"7e94f34a","669":"198e012b","744":"f9f28c27","988":"9462af61"}[chunkId] + ".chunk.js";
};